/**
 * Function that takes in a string, and returns a new string with all occurrences of
 * characterToRemove removed.
 */

export const removeCharacter = (str, characterToRemove) => {
  const regex = new RegExp(characterToRemove.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g");

  return str.replace(regex, "");
};
